import axios from 'axios'

export default {
  fetchFilterTabsOrderHistory () {
    return axios.get('/api/order/get-filters-data')
  }
}
